import Api from "@/api";
const route = "providers";

const store = async body => {
  const result = await Api.post(`v1/${route}`, body);
  return result.data;
};

const update = async (body, id) => {
  const result = await Api.put(`v1/${route}`, id, body);
  return result.data;
};

const index = async query => {
  const result = await Api.query(`v1/${route}`, query);
  return result.data;
};

const getFormaDePagamento = async () => {
  const result = await Api.query(`v1/${route}/getFormaPagamento`);
  return result.data;
};

const updateAndValidate = async (body, id) => {
  const result = await Api.put(`v1/${route}/${id}/validation`, "", body);
  return result.data;
};

const get = async id => {
  const result = await Api.get(`v1/${route}`, id);
  result.data.finances.forEach(element => {
    if (element.date_inactivity) {
      element.active = false;
    } else {
      element.active = true;
    }
  });
  result.data.employer_number = result.data.employer_number.toString();
  if (result.data.employer_number.length > 11) {
    result.data.employer_number = result.data.employer_number.padStart(14, "0");
  } else {
    result.data.employer_number = result.data.employer_number.padStart(11, "0");
  }
  return result.data;
};

const getReceitaInfo = async cnpj => {
  const result = await Api.get(`v1/receita`, cnpj);
  return result.data;
};

const getRecipeCode = async query => {
  const result = await Api.query(`v1/recipe_code`, query);
  return result.data;
};

const getIss = async query => {
  const result = await Api.query(`v1/regime_iss`, query);
  return result.data;
};

const getDocuments = async id => {
  const result = await Api.query(`v1/${route}/${id}/documents`);
  return result.data;
};

const getHistory = async (id, query) => {
  const result = await Api.query(`v1/${route}/${id}/documents/history`, query);
  return result.data;
};

const deleteHistory = async (id, body) => {
  const result = await Api.put(
    `v1/${route}/${id}/documents/history/delete`,
    "",
    body
  );
  return result.data;
};

export default {
  store,
  index,
  update,
  getFormaDePagamento,
  updateAndValidate,
  get,
  getReceitaInfo,
  getRecipeCode,
  getIss,
  getDocuments,
  getHistory,
  deleteHistory
};
